import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@features/auth/services/auth-service';

import { logger } from '@core/utils/logger';
export const RootGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Leemos los signals de forma síncrona
  const activeRole = authService.role();
  const employments = authService.employments();
  const isAuth = authService.isAuthenticated();

  const hasRootEmployment = employments.some((e) => e.role === 'ROLE_ROOT');

  // 1. Caso de éxito: Está autenticado y tiene el rol ROOT activo
  if (isAuth && activeRole === 'ROLE_ROOT') {
    return true;
  }

  // 2. Caso Intermedio: Tiene el empleo ROOT pero está con otro rol (ej: CLIENT)
  // Lo mandamos a que elija con qué "sombrero" quiere entrar
  if (hasRootEmployment) {
    logger.warn('Navegación', 'Sin rol ROOT activo: se redirige a elegir rol');
    return router.parseUrl('/role-selection');
  }

  // 3. Caso Fallido: No es ROOT ni tiene el empleo
  logger.warn('Navegación', 'Acceso denegado');
  return router.parseUrl('/auth/login');
};
